import { MeToPersonInstructionContainer } from '../containers/MeToPersonInstructionContainer/index'

export const MeToPersonInstructionPage = () => (
    <MeToPersonInstructionContainer/>
)